export default __webpack_public_path__ + "static/media/marketa-gramesova.064464c3.jpg";